// extracted by mini-css-extract-plugin
module.exports = {"container":"VisitorQuestion_container__JGQvh","text":"VisitorQuestion_text__1B54d","alert":"VisitorQuestion_alert__3qlcE"};